export default  {"src":"/_next/static/image/img/cerahKids/4-7.78bd0dd81525ba38d76f1f63ae27fee4.svg","height":512,"width":512};